<div class="container-fluid">
    <!-- Wrapper for the button skeletons -->
    <div class="d-flex flex-wrap justify-content-start gap-3">
      <!-- Loop through the buttonArray to generate the button skeletons -->
      <div *ngFor="let button of buttonArray" class="skeleton-button p-2">
      </div>
    </div>
  </div>
  